import { Button, Modal } from "react-bootstrap";

import './PreviewVideoTab.scss';
import { useRef, useState } from "react";
import playVideo from '../../images/playVideoIcon.svg';

const PreviewVideoTab = ({
    videoData,
    viewPoster,
    show,
    setIsViewModalOpen,
    setViewVideo,
    setViewPoster,
}) => {

    const videoRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            setIsPlaying(true);
        }
    };

    const handlePause = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleVideoClick = () => {
        if (videoRef.current && !videoRef.current.paused) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };

    return (
        <>
            <Modal
                show={show}
                // size="lg"
                centered
                className="preview-video-modal"
                dialogClassName="custom-modal-width"
            >
                <Modal.Header className="preview-video-modal-header">
                    <Modal.Title className="preview-video-title">
                        <span className="preview-video-title-label">Name:</span>
                        <span className="preview-video-content">{videoData?.name}{viewPoster?.name}</span>
                    </Modal.Title>
                    <Modal.Title className="preview-video-type">
                        <span className="preview-video-type-title">Type:</span>
                        <span className="preview-video-type-content">{videoData?.link?.split('.')?.pop()}{viewPoster?.link?.split('.')?.pop()}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="preview-video-modal-body" style={{ position: "relative" }}>
                    {videoData && (<>
                        <video width="100%" height="360" ref={videoRef} disablePictureInPicture controlsList="nodownload noplaybackrate" onPlay={handlePlay} controls onClick={handleVideoClick} onPause={handlePause}>
                            <source src={videoData?.link} type="video/mp4" />
                            {/* <source src={videoData?.link} type={videoType} /> */}
                        </video>
                        {!isPlaying && <div style={{ position: "absolute" }}>
                            <img src={playVideo} onClick={handlePlay} style={{ cursor: "pointer" }} />
                        </div>}
                        {/* {duration && <div style={{position: "absolute", bottom: "2%", right: "10%"}}>
                        <p>{duration.toFixed(2)}</p>
                    </div>} */}
                    </>)}
                    {viewPoster && (<>
                        <img className="img-fluid" src={viewPoster?.link} alt="" />
                    </>)}
                </Modal.Body>
                <div className="popupFooter">
                    <div className="popupFooterSeparator"></div>
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={() => {
                            setIsViewModalOpen(false);
                            setViewVideo(null);
                            setViewPoster(null);
                        }}
                    >
                        CLOSE
                    </Button>
                </div>
            </Modal>
        </>
    )
}

export default PreviewVideoTab;